import React, { useEffect, useState } from "react";
import api from "../../../../utils/api";

export default function ShareLead({ open, onClose, shareData }) {
  const [orgList, setOrgList] = useState([]);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(false);

  useEffect(() => {
    if (open) {
      fetchOrgList();
    }
  }, [open]);

  const fetchOrgList = async () => {
    try {
      setLoading(true);
      const res = await api.get("/company/fields-operation/crossLeadSharing");
      const data = res.data.data[0].crossLeadSharing || [];
      setOrgList(data || []);
    } catch (error) {
      console.error("Error fetching organization list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (url) => {
    setSelectedUrl(
      url +
        `&firstName=${shareData?.firstName || ""}&lastName=${
          shareData?.lastName || ""
        }&mobile=${shareData?.mobile || ""}&email=${
          shareData?.email || ""
        }&language=${shareData?.language || ""}&city=${shareData?.city || ""}`
    );
    setIframeLoading(true);
  };

  const handleClose = () => {
    setSelectedUrl("");
    setIframeLoading(false);
    onClose();
  };

  return (
    <>
      {/* Bootstrap Modal */}
      <div
        className={`modal fade ${open ? "show" : ""}`}
        style={{ display: open ? "block" : "none"}}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="shareLeadModalLabel"
        aria-hidden={!open}
      >
        <div
          className="modal-dialog modal-xxl"
          style={{
            maxWidth: "70vw",
            height: "90vh", // Set modal-dialog height
            margin: "auto",
            display: "flex",
            alignItems: "center",
          }}
          role="document"
        >
          <div
            className="modal-content"
            style={{
              height: "90vh", // Set modal-content height
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Modal Header */}
            <div className="modal-header text-black bg-white" style={{ borderBottom: "1px solid #dee2e6" }}>
              <h5 className="modal-title fw-bold" id="shareLeadModalLabel">
                <i className="fas fa-share-alt me-2"></i>
                Share Lead
              </h5>
              <button
                type="button"
                className="btn-close btn-close-black"
                onClick={handleClose}
                aria-label="Close"
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body p-0" style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span className="ms-3 text-muted">Loading organizations...</span>
                </div>
              ) : (
                <div className="row g-0 h-100" style={{ height: "100%" }}>
                  {/* Left Sidebar - Organization List */}
                  <div className="col-lg-3 col-md-4 border-end bg-light" style={{ height: "100%" }}>
                    <div className="p-3 border-bottom bg-white">
                      <h6 className="mb-0 text-muted fw-semibold">
                        <i className="fas fa-building me-2"></i>
                        Organizations ({orgList.length})
                      </h6>
                    </div>
                    <div
                      className="overflow-auto"
                      style={{ height: "calc(90vh - 56px)" }} // 56px is approx header height
                    >
                      {orgList.length === 0 ? (
                        <div className="text-center py-4">
                          <i className="fas fa-inbox fa-2x text-muted mb-2"></i>
                          <p className="text-muted mb-0">No organizations available</p>
                        </div>
                      ) : (
                        <div className="list-group list-group-flush">
                          {orgList.map((org, index) => (
                            <button
                              key={index}
                              type="button"
                              className={`list-group-item list-group-item-action border-0 py-3 px-4 ${
                                selectedUrl.includes(org?.url || "")
                                  ? "bg-secondary-subtle text-white"
                                  : "text-dark"
                              }`}
                              onClick={() => handleSelect(org.url)}
                            >
                              <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                  <h6 className="mb-1 fw-semibold text-capitalize">
                                    {org?.title || "Untitled Organization"}
                                  </h6>
                                </div>
                              </div>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Right Content - Iframe Preview */}
                  <div className="col-lg-9 col-md-8" style={{ height: "100%" }}>
                    <div className="h-100 d-flex flex-column">
                      {selectedUrl ? (
                        <>
                          {/* Iframe Container */}
                          <div className="flex-grow-1 position-relative" style={{ minHeight: 0 }}>
                            <iframe
                              src={selectedUrl}
                              title="Lead Preview"
                              onLoad={() => setIframeLoading(false)}
                              className="w-100 h-100 border-0"
                              style={{
                                minHeight: "100%",
                                height: "100%",
                                display: iframeLoading ? "none" : "block",
                              }}
                              sandbox="allow-same-origin allow-scripts allow-forms"
                            />
                            {iframeLoading && (
                              <div className="position-absolute top-50 start-50 translate-middle">
                                <div className="text-center">
                                  <div className="spinner-border text-primary mb-3" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                  <p className="text-muted">Loading preview...</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      ) : (
                        <div className="h-100 d-flex align-items-center justify-content-center">
                          <div className="text-center py-5">
                            <i className="fas fa-mouse-pointer fa-3x text-muted mb-3"></i>
                            <h5 className="text-muted mb-2">Select an Organization</h5>
                            <p className="text-muted mb-0">
                              Choose an organization from the list to preview the lead sharing form.
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal Backdrop */}
      {open && <div className="modal-backdrop fade show"></div>}
    </>
  );
}